/**
 * Preloaded standard couple list
 */
export const CoupleList: string[] = [
    'bride',
    'groom'
];
